<div [class.other-message]="messageType === CHAT_MESSAGE_TYPE.BAKERY"
     [class.my-message]="messageType === CHAT_MESSAGE_TYPE.CUSTOMER">
  @for (item of requestDetails; track item.sid) {
    @switch (item.type) {
      @default {
        <answer-msg
          class="pinned-info-container"
          [questionTitle]="item.questionTitle"
          [answer]="$any(item).answer"
        ></answer-msg>
      }
      @case (REQUEST_QUESTION_TYPES.UPLOAD_IMAGE) {
        <images-msg
          class="pinned-info-container"
          [questionTitle]="item.questionTitle"
          [images]="$any(item).images"
          (onShowImage)="showImage($event)"
        ></images-msg>
      }
      @case (REQUEST_QUESTION_TYPES.MULTIPLE_CHOICE) {
        <choices-msg
          class="pinned-info-container"
          [questionTitle]="item.questionTitle"
          [choices]="$any(item).choices"
        ></choices-msg>
      }
    }
  }

  @if (showDeliveryDetails) {
    @if (isToDoor) {
      <div class="pinned-info-container">
        <div class="text-muted-warm font-xs line-height-1"
             [translate]="'common.delivery.deliveryAddress'">Delivery address
        </div>

        <div class="mt-1 font-md">
          {{ deliveryOrder.deliveryAddress }}<br>
          {{ deliveryOrder.deliveryPostNumber }} {{ deliveryOrder.deliveryCity }}
        </div>
      </div>
    }

    @if (isPickup) {
      <div class="pinned-info-container">
        <div class="text-muted-warm font-xs line-height-1"
             [translate]="'common.delivery.pickUpLocation'">Outlet
        </div>

        <div class="mt-1 font-md">
          {{ deliveryOrder.outlet?.name || deliveryOrder.deliveryAddress }}
        </div>
      </div>
    }

    <div class="pinned-info-container">
      <div class="font-xs text-muted-warm lh-1">
        @if (isToDoor) {
          <span [translate]="'common.delivery.deliveryTime'"></span>
        }

        @if (isPickup) {
          <span [translate]="'common.delivery.pickUpTime'"></span>
        }
      </div>

      <ui-order-delivery-time
        class="font-md"
        [deliveryDate]="deliveryOrder.deliveryDate"
        [deliveryTime]="deliveryOrder.deliveryTime"
      ></ui-order-delivery-time>
    </div>
  }

  <div class="text-end font-xxs font-mute">
    {{ requestCreatedDate | i18nDate : 'DD MMM YY HH:mm' }}
  </div>
</div>
